import { SET_GLOBAL_FILTER_CONTENT } from "./GlobalFiltersAction";
import { SET_ACTIVE_FILTER_ITEM } from "./GlobalFiltersAction"
import { SET_CURRENT_GLOBAL_FILTER } from "./GlobalFiltersAction"
import { SET_GLOBAL_FILTERS_LIST } from "./GlobalFiltersAction"
import { SET_VISIBILITY } from "./GlobalFiltersAction"
import { UPDATE_GLOBAL_FILTER } from "./GlobalFiltersAction"
import { REFRESH_ALL_STATUS } from "./GlobalFiltersAction"
import { SET_POPUP } from "./GlobalFiltersAction"
import { RESET_POPUP } from "./GlobalFiltersAction"
import { CLEAR } from "./GlobalFiltersAction"
import { SET_NAVIGATION_STATE } from "./GlobalFiltersAction"
import { SET_DASHBOARD_SWITCH_STATE } from "./GlobalFiltersAction"

/**
 * Reducer for Global Filters
 * --------------------------
 * 
 * @param {Object} state - Current state
 * @param {Object} action - Action dispatched to the reducer
 * @returns {Object} New state object
 *
 * State Properties:
 * -----------------
 * 
 * - __filterItemsDetails__:      Details of filter items including values, configuration, etc.
 * - __filterItemsTargetList__:   Object mapping filter IDs to their target configurations
 * - __activeFilterItem__:        Currently active filter item for target settings
 * - __currentGlobalFilter__:     ID of the currently selected filter group
 * - __globalFiltersList__:       Array containing all available filter groups
 * - __refreshAllStatus__:        Boolean indicating whether all filters should be refreshed
 * - __navigationState__:         The Last global filter state of each dashboard of the current navigation process.
 */
export default function GlobalFiltersReducer(
    state = {
        filterItemsDetails: {},
        filterItemsTargetList: {},
        originalFilterItemsTargetList: {},
        activeFilterItem: "",
        currentGlobalFilter: "",
        globalFiltersList: [],
        refreshAllStatus: null,
        navigationState: {},
        dashboardSwitchState: {}
    },
    action
) {
    switch (action.type) {
        case SET_GLOBAL_FILTER_CONTENT:
            return {
                ...state,
                filterItemsDetails: action.payload?.filterItemsDetails ?? state?.filterItemsDetails,
                filterItemsTargetList: action.payload?.filterItemsTargetList ?? state?.filterItemsTargetList,
                originalFilterItemsTargetList: action.payload?.originalFilterItemsTargetList ?? state?.originalFilterItemsTargetList
            };
        case SET_ACTIVE_FILTER_ITEM:
            return {
                ...state,
                activeFilterItem: action.payload
            }
        case SET_CURRENT_GLOBAL_FILTER:
            return {
                ...state,
                currentGlobalFilter: action.payload
            }
        case SET_GLOBAL_FILTERS_LIST:
            return {
                ...state,
                globalFiltersList: action.payload
            }
        case SET_VISIBILITY:
            return {
                ...state,
                visibility: action.payload
            }
        case UPDATE_GLOBAL_FILTER:
            return {
                ...state,
                globalFiltersList: state.globalFiltersList.map((obj) =>
                    obj.id === action.payload.id
                        ? { ...obj, ...action.payload }
                        : obj
                )
            }
        case REFRESH_ALL_STATUS:
            return {
                ...state,
                refreshAllStatus: action.payload ? {
                    status: action.payload?.status ?? false,
                    returnToDefault: action.payload?.returnToDefault ?? false
                } : null
            }
        case CLEAR:
            return {
                ...state,
                filterItemsDetails: {},
                filterItemsTargetList: {},
                originalFilterItemsTargetList: {},
                activeFilterItem: "",
                currentGlobalFilter: "",
                globalFiltersList: action.payload === true ? [] : state.globalFiltersList,
                refreshAllStatus: null
            }
        case SET_POPUP:
            return {
                ...state,
                popupContent: action.payload
            }

        case RESET_POPUP:
            return {
                ...state,
                popupContent: null
            }
        case SET_NAVIGATION_STATE:
            return {
                ...state,
                navigationState: action.payload
            }
        case SET_DASHBOARD_SWITCH_STATE:
            return {
                ...state,
                dashboardSwitchState: action.payload
            }
        default:
            return state;
    }
}